// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2W1Xa","clinicsSelect":"TableHeading_clinicsSelect__2xk0k"};